import { Button, FormGroup, Modal, ReadOnly } from "@mwi/ui";
import { useLogoutMutation } from "api";
import ChangePasswordPage from "components/change-password";
import useTitle from "hooks/useTitle";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearChangePasswordStep, logout } from "slices/auth";
import { RootState } from "store";

const AccountPage = () => {
  useTitle("Account");

  const dispatch = useDispatch();

  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);

  const user = useSelector((state: RootState) => state.auth.user);

  const [submitLogout] = useLogoutMutation();

  const triggerLogout = async () => {
    await submitLogout();
    dispatch(logout());
  };

  const handleEditPassword = () => {
    setShowChangePasswordModal(true);
  };

  const closeChangePasswordModal = () => {
    setShowChangePasswordModal(false);
    dispatch(clearChangePasswordStep());
  };

  return (
    <>
      <div className="mb-12">
        <h1 className="text-[28px] leading-[34px] tablet:text-5xl tablet:leading-[58px]">
          Account Details
        </h1>
      </div>

      <div className="max-w-lg">
        <FormGroup hideError>
          <ReadOnly heading="Email Address" value={user!.email} hasDivider />
        </FormGroup>

        <FormGroup hideError>
          <ReadOnly
            heading="Password"
            value="•••••••••"
            hasDivider
            actionText="Edit"
            actionOnClick={handleEditPassword}
          />
        </FormGroup>

        <div className="flex items-end flex-grow mt-8 tablet:max-w-sm">
          <Button variant="outlined" block onClick={triggerLogout}>
            Log out
          </Button>
        </div>

        <Modal
          isOpen={showChangePasswordModal}
          onClose={closeChangePasswordModal}
        >
          <ChangePasswordPage onDone={closeChangePasswordModal} />
        </Modal>
      </div>
    </>
  );
};

export default AccountPage;
